import React, { useState, useEffect } from 'react';
import { MessageCircle, Phone, X } from 'lucide-react';
import { companyInfo } from '../mockData';

const FloatingButtons = () => {
  const [showWhatsApp, setShowWhatsApp] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowWhatsApp(true), 50);
    return () => clearTimeout(timer);
  }, []);

  const handleWhatsAppClick = () => {
    const message = "Hi, I want to book a taxi";
    window.open(`https://wa.me/91${companyInfo.phone[0]}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <>
      {/* WhatsApp Button */}
      <button
        onClick={handleWhatsAppClick}
        className={`fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl z-50 transform transition-all duration-500 hover:scale-110 ${
          showWhatsApp ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
        }`}
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="w-6 h-6" />
      </button>

      {/* Call Button */}
      <a
        href={`tel:${companyInfo.phone[0]}`}
        className={`fixed bottom-24 right-6 bg-orange-600 hover:bg-orange-700 text-white p-4 rounded-full shadow-2xl z-50 transform transition-all duration-500 hover:scale-110 ${
          showWhatsApp ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
        }`}
        style={{ transitionDelay: '100ms' }}
        aria-label="Call Now"
      >
        <Phone className="w-6 h-6" />
      </a>
    </>
  );
};

export default FloatingButtons;
